import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyController/CtrlEmployeeReqs/CtrlEmployeeReqs';

const failMsg = (result) => result?.response?.data?.message || result?.message || undefined;

// ---------- Employees ----------

function* getEmployeesList(action) {
    try {
        const result = yield call(req.getEmployeesListReq, action);
        if (result?.success === true) {
            yield put({
                type: types.CTRL_EMPLOYEE_LIST_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.CTRL_EMPLOYEE_LIST_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_EMPLOYEE_LIST_FAILURE, message: e?.message });
    }
}

function* getSocietyDropdown(action) {
    try {
        const result = yield call(req.getSocietyDropdownReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_SOCIETY_DROPDOWN_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_SOCIETY_DROPDOWN_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_SOCIETY_DROPDOWN_FAILURE, message: e?.message });
    }
}

function* getEmployeeDirectory(action) {
    try {
        const result = yield call(req.getEmployeeDirectoryReq, action);
        if (result?.success === true) {
            yield put({
                type: types.CTRL_EMPLOYEE_DIRECTORY_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.CTRL_EMPLOYEE_DIRECTORY_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_EMPLOYEE_DIRECTORY_FAILURE, message: e?.message });
    }
}

function* getEmployeeSocieties(action) {
    try {
        const result = yield call(req.getEmployeeSocietiesReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_EMPLOYEE_SOCIETIES_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_EMPLOYEE_SOCIETIES_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_EMPLOYEE_SOCIETIES_FAILURE, message: e?.message });
    }
}

function* assignEmployeeSociety(action) {
    try {
        const result = yield call(req.assignEmployeeSocietyReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_ASSIGN_EMPLOYEE_SOCIETY_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_ASSIGN_EMPLOYEE_SOCIETY_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_ASSIGN_EMPLOYEE_SOCIETY_FAILURE, message: e?.message });
    }
}

function* changeEmployeeSocietyRole(action) {
    try {
        const result = yield call(req.changeEmployeeSocietyRoleReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE_FAILURE, message: e?.message });
    }
}

function* getEmployeeStats(action) {
    try {
        const result = yield call(req.getEmployeeStatsReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_EMPLOYEE_STATS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_EMPLOYEE_STATS_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_EMPLOYEE_STATS_FAILURE, message: e?.message });
    }
}

function* getEmployeeDetails(action) {
    try {
        const result = yield call(req.getEmployeeDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_EMPLOYEE_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_EMPLOYEE_DETAILS_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_EMPLOYEE_DETAILS_FAILURE, message: e?.message });
    }
}

function* createEmployee(action) {
    try {
        const result = yield call(req.createEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_CREATE_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_CREATE_EMPLOYEE_FAILURE, message: failMsg(result) });
            // Hand the full error envelope (incl. data.code for the duplicate guard) to the caller.
            action.data?.onError?.(result?.response?.data || result);
        }
    } catch (e) {
        yield put({ type: types.CTRL_CREATE_EMPLOYEE_FAILURE, message: e?.message });
        action.data?.onError?.(e?.response?.data);
    }
}

function* updateEmployee(action) {
    try {
        const result = yield call(req.updateEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_UPDATE_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_UPDATE_EMPLOYEE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_UPDATE_EMPLOYEE_FAILURE, message: e?.message });
    }
}

function* deleteEmployee(action) {
    try {
        const result = yield call(req.deleteEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_DELETE_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_DELETE_EMPLOYEE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_DELETE_EMPLOYEE_FAILURE, message: e?.message });
    }
}

function* bulkStatusEmployee(action) {
    try {
        const result = yield call(req.bulkStatusEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_BULK_STATUS_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_BULK_STATUS_EMPLOYEE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_BULK_STATUS_EMPLOYEE_FAILURE, message: e?.message });
    }
}

function* bulkReassignEmployee(action) {
    try {
        const result = yield call(req.bulkReassignEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_BULK_REASSIGN_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_BULK_REASSIGN_EMPLOYEE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_BULK_REASSIGN_EMPLOYEE_FAILURE, message: e?.message });
    }
}

function* searchEmployeeByEmail(action) {
    try {
        const result = yield call(req.searchEmployeeByEmailReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_SEARCH_EMPLOYEE_BY_EMAIL_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE, message: failMsg(result) || 'Employee not found' });
        }
    } catch (e) {
        yield put({ type: types.CTRL_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE, message: e?.message });
    }
}

function* linkExistingEmployee(action) {
    try {
        const result = yield call(req.linkExistingEmployeeReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_LINK_EXISTING_EMPLOYEE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_LINK_EXISTING_EMPLOYEE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_LINK_EXISTING_EMPLOYEE_FAILURE, message: e?.message });
    }
}

function* getEmployeeTypesDropdown(action) {
    try {
        const result = yield call(req.getEmployeeTypesDropdownReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_EMPLOYEE_TYPES_DROPDOWN_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_EMPLOYEE_TYPES_DROPDOWN_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_EMPLOYEE_TYPES_DROPDOWN_FAILURE, message: e?.message });
    }
}

// ---------- Employee Types (roles) catalog ----------

function* getEmployeeRoles(action) {
    try {
        const result = yield call(req.getEmployeeRolesReq, action);
        if (result?.success === true) {
            yield put({
                type: types.CTRL_EMPLOYEE_ROLE_LIST_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.CTRL_EMPLOYEE_ROLE_LIST_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_EMPLOYEE_ROLE_LIST_FAILURE, message: e?.message });
    }
}

function* getEmployeeRoleDetails(action) {
    try {
        const result = yield call(req.getEmployeeRoleDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_EMPLOYEE_ROLE_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.CTRL_EMPLOYEE_ROLE_DETAILS_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_EMPLOYEE_ROLE_DETAILS_FAILURE, message: e?.message });
    }
}

function* createEmployeeRole(action) {
    try {
        const result = yield call(req.createEmployeeRoleReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_CREATE_EMPLOYEE_ROLE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_CREATE_EMPLOYEE_ROLE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_CREATE_EMPLOYEE_ROLE_FAILURE, message: e?.message });
    }
}

function* updateEmployeeRole(action) {
    try {
        const result = yield call(req.updateEmployeeRoleReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_UPDATE_EMPLOYEE_ROLE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_UPDATE_EMPLOYEE_ROLE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_UPDATE_EMPLOYEE_ROLE_FAILURE, message: e?.message });
    }
}

function* deleteEmployeeRole(action) {
    try {
        const result = yield call(req.deleteEmployeeRoleReq, action);
        if (result?.success === true) {
            yield put({ type: types.CTRL_DELETE_EMPLOYEE_ROLE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.CTRL_DELETE_EMPLOYEE_ROLE_FAILURE, message: failMsg(result) });
        }
    } catch (e) {
        yield put({ type: types.CTRL_DELETE_EMPLOYEE_ROLE_FAILURE, message: e?.message });
    }
}

export default function* CtrlEmployeeSaga() {
    yield takeLatest(types.CTRL_SOCIETY_DROPDOWN, getSocietyDropdown);
    yield takeLatest(types.CTRL_EMPLOYEE_LIST, getEmployeesList);
    yield takeLatest(types.CTRL_EMPLOYEE_DIRECTORY, getEmployeeDirectory);
    yield takeLatest(types.CTRL_EMPLOYEE_STATS, getEmployeeStats);
    yield takeLatest(types.CTRL_EMPLOYEE_DETAILS, getEmployeeDetails);
    yield takeLatest(types.CTRL_EMPLOYEE_SOCIETIES, getEmployeeSocieties);
    yield takeLatest(types.CTRL_ASSIGN_EMPLOYEE_SOCIETY, assignEmployeeSociety);
    yield takeLatest(types.CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE, changeEmployeeSocietyRole);
    yield takeLatest(types.CTRL_CREATE_EMPLOYEE, createEmployee);
    yield takeLatest(types.CTRL_UPDATE_EMPLOYEE, updateEmployee);
    yield takeLatest(types.CTRL_DELETE_EMPLOYEE, deleteEmployee);
    yield takeLatest(types.CTRL_BULK_STATUS_EMPLOYEE, bulkStatusEmployee);
    yield takeLatest(types.CTRL_BULK_REASSIGN_EMPLOYEE, bulkReassignEmployee);
    yield takeLatest(types.CTRL_SEARCH_EMPLOYEE_BY_EMAIL, searchEmployeeByEmail);
    yield takeLatest(types.CTRL_LINK_EXISTING_EMPLOYEE, linkExistingEmployee);
    yield takeLatest(types.CTRL_EMPLOYEE_TYPES_DROPDOWN, getEmployeeTypesDropdown);
    yield takeLatest(types.CTRL_EMPLOYEE_ROLE_LIST, getEmployeeRoles);
    yield takeLatest(types.CTRL_EMPLOYEE_ROLE_DETAILS, getEmployeeRoleDetails);
    yield takeLatest(types.CTRL_CREATE_EMPLOYEE_ROLE, createEmployeeRole);
    yield takeLatest(types.CTRL_UPDATE_EMPLOYEE_ROLE, updateEmployeeRole);
    yield takeLatest(types.CTRL_DELETE_EMPLOYEE_ROLE, deleteEmployeeRole);
}
